'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = exports.BaseLayout = exports.AdminLayout = undefined;

var _AdminLayout = require('./AdminLayout');

var _AdminLayout2 = _interopRequireDefault(_AdminLayout);

var _BaseLayout = require('./BaseLayout');

var _BaseLayout2 = _interopRequireDefault(_BaseLayout);

var _Sidebar = require('./Sidebar');

var _Sidebar2 = _interopRequireDefault(_Sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AdminLayout = _AdminLayout2.default;
exports.BaseLayout = _BaseLayout2.default;
exports.Sidebar = _Sidebar2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/index.js
// module id = 10
// module chunks = 0